export default "__VITE_ASSET__$nBQBD8r__"